import config from "config";
import { RANKING_STRATEGY_CHANGE } from "actions/const";

function reducer(state = config.state.rankingStrategy, action) {
  if (action.type === RANKING_STRATEGY_CHANGE) {
    return {
      ...state,
      rankingStrategy: action.rankingStrategy,
    };
  }
  return state;
}
export default reducer;
